import React from "react";
import { useLocation, useParams } from "react-router-dom";
import queryString from "query-string";

const PaymentSuccess = (props) => {
    const { id } = useParams();
    const location = useLocation();

    const { name, amount } = queryString.parse(location.search);

    return (
        <>
            <h1 style={{ textAlign: "center" }}>
                Thank You, <span style={{ color: "#ea4633" }}>{name}</span>
            </h1>
            <div
                style={{
                    maxWidth: 860,
                    margin: "50px auto",
                }}
            >
                <p style={{ fontSize: 16 }}>
                    A BIG Thank You for your donation of INR {amount} to Infant
                    India. All of us at Infant India - most importantly those
                    who benefit from our work - sincerely appreciate your
                    support. The funds contributed by you may be pooled together
                    and allocated towards our rehabilitation initiatives for
                    kids of Infant India. To know more about our work and
                    achievements in India, please visit us at{" "}
                    <a href="http://www.infantindia.org">www.infantindia.org</a>
                    . Also, do feel free to write to us with your suggestions or
                    feedback at{" "}
                    <a href="mailto:infantindiapali@gmail.com">
                        infantindiapali@gmail.com
                    </a>
                    . We are always delighted to hear from donors like you. You
                    may also reach us at{" "}
                    <a href="tel:+91 9422693585">+91 9422693585</a>. Here is,
                    for your kind perusal is the donation acknowledgement
                    receipt of the donation amount received from you:{" "}
                    <a
                        href={`${process.env.REACT_APP_BACKEND_URL}/receipt/${id}`}
                    >
                        Donation Receipt
                    </a>
                </p>
            </div>
            <div style={{ textAlign: "center" }}>
                <a
                    href={`${process.env.REACT_APP_BACKEND_URL}/receipt/${id}`}
                    className="btn btn-secondary"
                >
                    Donation Receipt
                </a>
            </div>
        </>
    );
};

export default PaymentSuccess;
